<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <base-card title="Import Box">
        <form class="space-y-4" @submit.prevent="onProcess">
          <base-input
            label="Pilih File"
            fullwidth
            :shadow="false"
            type="file"
            accept=".csv"
            size="padding-md"
            required
            @change="onChangeFile"
          />
          <base-button type="submit" :loading="loadingProcess.visible">{{
            loadingProcess.visible ? loadingProcessLabel : 'Proses'
          }}</base-button>
        </form>
      </base-card>

      <base-card title="Keterangan">
        <dl class="grid gap-4">
          <div class="w-full">
            <dt class="text-sm text-gray-900">
              Contoh file import box (.csv)
            </dt>
            <dd class="mt-1">
              <a
                href="/import-box-example/import_box_kode_office_ddmmyyyy_hhmm.csv"
                class="text-sm font-medium text-green-600"
                >import_box_kode_office_ddmmyyyy_hhmm.csv</a
              >
            </dd>
          </div>
        </dl>
      </base-card>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters, mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  data() {
    return {
      file: null,
      loadingPage: false,
      loadingProcess: {
        visible: false,
        text: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    loading() {
      return this.loadingPage;
    },
    loadingProcessLabel() {
      return {
        wait: 'Mengirim Data',
        queued: 'Menunggu Diproses',
        processing: 'Sedang Diproses',
      }[this.loadingProcess.text];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onProgress
      );
    },
    async loadJobStatus() {
      this.loadingPage = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'import_box',
          },
        }
      );

      if (!err) {
        const { running, status } = res;

        if (running) {
          this.startLoadingProcess(status);
        }
      }

      this.loadingPage = false;
    },
    onProgress(e) {
      if (e.type === 'App\\Notifications\\ImportBoxProcessUpdated') {
        if (e.status === 'processing') {
          this.startLoadingProcess('processing');
        } else if (e.status === 'failed') {
          this.stopLoadingProcess();

          this.createAlert({
            status: 'error',
            data: e.message,
          });
        } else if (e.status === 'finished') {
          this.stopLoadingProcess();

          this.createAlert({
            status: 'success',
            data: 'Berhasil mengimport box',
          });
        }
      }
    },
    onChangeFile(e) {
      this.file = e.target.files[0];
    },
    async onProcess() {
      this.startLoadingProcess('wait');

      const formData = new FormData();

      formData.append('file', this.file);

      const [, err] = await this.request(
        '/api/v1/products/-actions/import-box',
        {
          method: 'post',
          data: formData,
        }
      );

      if (!err) {
        this.startLoadingProcess('queued');
      } else {
        this.stopLoadingProcess();
      }
    },
    removeListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onProgress
        );
      }
    },
    startLoadingProcess(text) {
      this.loadingProcess.text = text;
      this.loadingProcess.visible = true;
    },
    stopLoadingProcess() {
      this.loadingProcess.visible = false;
    },
  },
  created() {
    this.loadJobStatus();
    this.addListener();
  },
  beforeRouteLeave(to, from, next) {
    this.removeListener();
    next();
  },
};
</script>
